module.exports = __webpack_public_path__ + "static/media/btn_edit_768x512.97996a43.png";